import type { Achievement, AchievementSuggestion } from '@/types'
import { apiClient } from './client'

type AchievementFilters = {
  date_from?: string
  date_to?: string
  rating?: number[]
  ai_rating?: number[]
  ordering?: string
  search?: string
}

export const getAchievements = (filters: AchievementFilters = {}) => {
  const params = new URLSearchParams()
  if (filters.date_from) params.set('date_from', filters.date_from)
  if (filters.date_to) params.set('date_to', filters.date_to)
  if (filters.rating) filters.rating.forEach((r) => params.append('rating', String(r)))
  if (filters.ai_rating) filters.ai_rating.forEach((r) => params.append('ai_rating', String(r)))
  if (filters.ordering) params.set('ordering', filters.ordering)
  if (filters.search) params.set('search', filters.search)
  return apiClient.get<Achievement[]>('/achievements/', { params }).then((r) => r.data)
}

export const getAchievement = (id: number) =>
  apiClient.get<Achievement>(`/achievements/${id}/`).then((r) => r.data)

export const createAchievement = (data: Partial<Achievement>) =>
  apiClient.post<Achievement>('/achievements/', data).then((r) => r.data)

export const updateAchievement = (id: number, data: Partial<Achievement>) =>
  apiClient.patch<Achievement>(`/achievements/${id}/`, data).then((r) => r.data)

export const deleteAchievement = (id: number) =>
  apiClient.delete(`/achievements/${id}/`)

export const getSuggestions = (q: string) =>
  apiClient.get<AchievementSuggestion[]>('/achievements/suggestions/', { params: { q } }).then((r) => r.data)


export const resetAiAnalysis = (id: number) =>
  apiClient.patch<Achievement>(`/achievements/${id}/`, {
    is_ai_analyzed: false,
    ai_rating: null,
  }).then((r) => r.data)

export type AnalyzeResultItem = {
  id: number
  title: string
  ai_rating: number | null
  earned_points: number
}

export type AnalyzeResult = {
  processed: number
  level_before: number
  level_after: number
  total_earned_points: number
  /** 6ステータス＋luck。時間減衰前の生の獲得量。 */
  total_status_gain: Record<string, number>
  items: AnalyzeResultItem[]
}

export const runAiAnalysis = () =>
  apiClient
    .post<AnalyzeResult>('/achievements/analyze/')
    .then((r) => r.data)
